/* Product Tag Filters - Good for any number of filters on any type of collection pages */
  var collFilters = jQuery('.coll-filter');
    
  collFilters.change(function() {
    var newTags = [];
    collFilters.each(function() {
       if(jQuery(this).is(':checked')){
        newTags.push(jQuery(this).val());
      }
    });
    if (newTags.length) {
      var query = newTags.join('+');
      
      	window.location.href = ('/collections/all/tag').replace('tag', query);  
	  
    }
    else {
      
      	window.location.href = '/collections/all';
      
    }
  });